import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import PropTypes from 'prop-types';
import IntroSection from './components/introSection';
import HowItWorks from './components/howItWorks';
import LandingContent from './components/landingContent';
import SignInSection from './components/signInSection';
import FooterSection from './components/footer';
import { SessionExpireDialog, MigratedDialog } from '../../components';

const styles = {
  mainContainer: {
    margin: 0,
    overflow: 'hidden',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  scrollBttn: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
    height: '40px',
    color: 'white',
    padding: '0',
    width: '40px',
    background: '#000',
    borderRadius: '50%',
    curser: 'pointer',
  },
};

let scrollTop;

class LandingPage extends React.Component {
  state = {
    open: false,
    migrated: false,
  };

  componentDidMount = () => {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    if (params.get('expired') === 'yes') {
      this.setState({ open: true });
      params.delete('expired');
      window.history.replaceState({}, '', '/');
    }
    if (params.get('migrated') === 'yes') {
      this.setState({ migrated: true });
      params.delete('migrated');
      window.history.replaceState({}, '', '/');
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleExpiredClose = () => {
    this.setState({ open: false });
  };

  handleMigratedClose = () => {
    this.setState({ migrated: false });
  };

  handleScroll = () => {
    if (scrollTop) { window.scrollTo(0, document.body.scrollHeight); } else { window.scrollTo(document.body.scrollHeight, 0); }
  }

  render() {
    const {
      domain,
      clientID,
      redirectURI,
      authServer,
      classes,
    } = this.props;

    const { open, migrated } = this.state;

    const authProps = {
      domain,
      clientID,
      redirectURI,
      authServer,
    };

    return (
      <div className={classes.mainContainer}>
        <SessionExpireDialog
          open={open}
          handleClose={this.handleExpiredClose}
        />
        <MigratedDialog
          migrated={migrated}
          handleClose={this.handleMigratedClose}
        />
        <ArrowDropUp id="scrollBttn" className={classes.scrollBttn} onClick={this.handleScroll} />
        <IntroSection {...authProps} />
        {/* <HowItWorks /> */}
        <LandingContent />
        <SignInSection {...authProps} />
        <FooterSection />
      </div>
    );
  }
}

window.onscroll = function (e) {
  scrollFunction();
  scrollTop = (this.oldScroll > this.scrollY);
  this.oldScroll = this.scrollY;
};

function scrollFunction() {
  const scrollBttn = document.getElementById('scrollBttn');

  if (scrollBttn) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      scrollBttn.style.display = 'block';
    } else {
      scrollBttn.style.display = 'none';
    }
  }
}


export default withStyles(styles)(LandingPage);

LandingPage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

LandingPage.defaultProps = {
  classes: {},
};
